import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { StateService } from '../services/state.service';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {

  constructor(
    private http: HttpClient,
    private stateService: StateService,
    private authService: AuthService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const roleData = route.data['role'] as string | string[];
    const allowedRoles = Array.isArray(roleData) ? roleData : [roleData];
    const currentUser = this.stateService.getCurrentUser();

    const hasRole = currentUser?.roles?.some(r => allowedRoles.includes(r));

    if (hasRole) return true;

    // Invalidate the server-side session cookie so the user can't bypass the
    // role check by reloading. Fire-and-forget — navigate immediately without
    // waiting for the response so there is no UX delay.
    this.http
      .post(`${environment.API_URL}/auth/logout`, {}, { withCredentials: true })
      .pipe(catchError(() => of(null)))
      .subscribe();

    this.authService.forceLogoutReload('/login?error=role');
    return false;
  }
}
